import React, { useEffect, useMemo, useRef, useState } from 'react';
import css_class from './ComboBox.module.css';

function GetGuid(): string {
    var result: string;
    var i: string;
    var j: number;

    result = '';
    for (j = 0; j < 32; j++) {
        if (j == 8 || j == 12 || j == 16 || j == 20) result = result + '-';
        i = Math.floor(Math.random() * 16)
            .toString(16)
            .toUpperCase();
        result = result + i;
    }
    return result;
}

export interface IComboBoxData {
    id: string;
    value: string;
}

export interface IPropsComboBox {
    data: IComboBoxData[];
    selected?: string;
    label?: string;
    invalid?: boolean;
    width?: string;
    placeholder?: string;
    disabled?: boolean;
    onClick?: (item: IComboBoxData) => void;
    onEnter?: (item: IComboBoxData) => void;
}
export interface IPropsInputComboBox {
    placeholder?: string;
    invalid?: boolean;
    width?: string;
    value?: string;
    disabled?: boolean;
    OnChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
    OnClick: () => void;
    OnKeyDown: (event: React.KeyboardEvent<HTMLInputElement>) => void;
}
export interface IPropsDataComboBox {
    data: IComboBoxData[];
    width?: string;
    value?: string;
    onClick: (item: IComboBoxData) => void;
}

const ComboBox: React.FC<IPropsComboBox> = ({
    data,
    selected,
    placeholder,
    disabled,
    label = '',
    width = '160px',
    invalid = false,
    onClick,
    onEnter
}) => {
    const [vis, setVis] = useState<boolean>(false);
    const [valueChang, setValue] = useState<string>('');
    const [EnterOk, setEnterOk] = useState<boolean>(false);
    const [dataView, setDataView] = useState<IComboBoxData[]>(data);
    const containerRef = useRef<HTMLDivElement>(null);

    React.useEffect(() => {
        setDataView(data);
    }, [data]);

    React.useEffect(() => {
        if (onEnter && EnterOk) {
            //console.log(valueChang);
            let _index: number = -1;
            data.forEach((item, ind) => {
                //console.debug(item.value+"=="+valueChang);
                if (item.value === valueChang) _index = ind;
            });
            //console.debug(_index);
            if (_index != -1) onEnter(data[_index]);
            else {
                let _item: IComboBoxData = { id: '', value: valueChang };
                _item.id = '';
                _item.value = valueChang;
                onEnter(_item);
            }
            setEnterOk(false);
        }
    }, [EnterOk]);

    let viewLabel = <div></div>;
    let height = '24px';
    if (label != '') {
        height = '48px';
        viewLabel = (
            <div style={{ width: width }} className={css_class.label}>
                {label}
            </div>
        );
    }

    useEffect(() => {
        if (!disabled) {
            let inputText = valueChang.toLowerCase();
            let newData: IComboBoxData[] = [];
            if (inputText !== '') {
                newData = data.filter((item) => item.value.toLowerCase().indexOf(inputText) >= 0);
            } else {
                newData = data;
            }
            setDataView(newData);
        }
    }, [valueChang]);

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setValue(event.currentTarget.value);
        if (!vis) setVis(!vis);
    };

    const ClickWin = () => {
        if (!disabled) setVis(!vis);
    };

    function handleKeyDown(event: React.KeyboardEvent<HTMLInputElement>) {
        if (onEnter) {
            if (event.key == 'Enter') {
                setEnterOk(true);
            }
        }
    }

    const handleClick = (item: IComboBoxData) => {
        setVis(false);
        if (onClick) onClick(item);
        setDataView(data);
    };

    function GetValue(): string {
        let defValue: string = '';
        if (selected) {
            data.forEach((item, ind) => {
                if (item.id == selected) {
                    defValue = item.value;
                }
            });
        }
        return defValue;
    }

    useEffect(() => {
        const iframe = document.getElementById('mainframe') as HTMLIFrameElement;

        function CloseDataView(e: any) {
            if (containerRef.current !== null && !containerRef.current.contains(e.target)) {
                setVis(false);
            }
        }

        window.addEventListener('mousedown', CloseDataView);
        if (iframe) {
            const iframeDocument = iframe.contentDocument || iframe.contentWindow?.document;

            if (iframeDocument) {
                iframeDocument.addEventListener('mousedown', CloseDataView);
            }
        }

        return () => {
            window.removeEventListener('mousedown', CloseDataView);
            if (iframe) {
                const iframeDocument = iframe.contentDocument || iframe.contentWindow?.document;
                if (iframeDocument) {
                    iframeDocument.removeEventListener('mousedown', CloseDataView);
                }
            }
        };
    }, []);

    return (
        <div ref={containerRef} style={{ height: height }}>
            {viewLabel}
            <InputView
                OnChange={handleChange}
                OnKeyDown={handleKeyDown}
                placeholder={placeholder}
                invalid={invalid}
                width={width}
                disabled={disabled}
                value={GetValue()}
                OnClick={ClickWin}
            />
            {vis && <DataView data={dataView} onClick={handleClick} width={width} value={selected} />}
        </div>
    );
};

class InputView extends React.Component<IPropsInputComboBox> {
    constructor(props: IPropsInputComboBox) {
        super(props);
    }

    shouldComponentUpdate(nextProps: IPropsInputComboBox) {
        let nextPropsStr: string = JSON.stringify(nextProps);
        let propsStr: string = JSON.stringify(this.props);
        if (nextPropsStr != propsStr) {
            //console.debug("Рендеринг компонент Textarea");
            //this.props.OnChange();
            return true;
        } else {
            //console.debug("Не рендеринг компонент Textarea");
            return false;
        }
    }

    render() {
        let id = GetGuid();
        let className: string = css_class.def;
        if (this.props.invalid) className += ' ' + css_class.invalid;
        let defValue: string = this.props.value != undefined ? this.props.value : '';
        let left = 'calc(100% - 16px)';
        if (this.props.width && this.props.width.indexOf('%') > -1) left = 'calc(' + this.props.width + ' + 10px)';

        return (
            <div key={id} className={css_class.main} style={{ width: this.props.width }}>
                <input
                    type="text"
                    className={className}
                    placeholder={this.props.placeholder}
                    defaultValue={`${defValue}`}
                    disabled={this.props.disabled}
                    onChange={this.props.OnChange}
                    onKeyDown={this.props.OnKeyDown}
                />
                <div style={{ left: left }} className={css_class.svg} onClick={() => this.props.OnClick()}>
                    <svg width="9" height="5" viewBox="0 0 9 5" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M0.137205 0.774744C-0.280154 0.351336 0.345885 -0.283775 0.798024 0.139632L4.4847 3.87973L8.20616 0.139632C8.62352 -0.283775 9.28434 0.351336 8.86698 0.774744L4.8325 4.86768C4.6586 5.0441 4.34558 5.0441 4.1369 4.86768L0.137205 0.774744Z"
                            fill="#AEAEAE"
                        />
                    </svg>
                </div>
            </div>
        );
    }
}

const DataView: React.FC<IPropsDataComboBox> = ({ data, width, value, onClick }) => {
    const [startIndex, setStartIndex] = useState(0);
    const containerRef = useRef<HTMLDivElement>(null);

    const itemHeight = 24; // Высота одного элемента
    const visibleCount = 15; // Количество видимых элементов

    // Если количество элементов меньше, чем visibleCount, используем их количество
    const actualVisibleCount = Math.min(data.length, visibleCount);

    const handleScroll = () => {
        if (containerRef.current) {
            const scrollTop = containerRef.current.scrollTop;
            const newStartIndex = Math.floor(scrollTop / itemHeight);
            setStartIndex(newStartIndex);
        }
    };

    const visibleData = useMemo(() => {
        return data.slice(startIndex, startIndex + actualVisibleCount);
    }, [startIndex, data, actualVisibleCount]);

    return (
        <div
            ref={containerRef}
            onScroll={handleScroll}
            style={{
                height: itemHeight * actualVisibleCount,
                overflowY: data.length > actualVisibleCount ? 'auto' : 'hidden',
                width: width ? `${width}px` : '300px'
            }}
            className={css_class.windows}>
            <div style={{ height: data.length * itemHeight, position: 'relative' }}>
                {visibleData.map((item, index) => (
                    <div
                        key={item.id}
                        className={`${css_class.data_item} ${value === item.id ? css_class.sel : ''}`}
                        style={{
                            position: 'absolute',
                            top: (startIndex + index) * itemHeight,
                            height: itemHeight,
                            width: '100%'
                        }}
                        title={item.value}
                        onClick={() => onClick(item)}>
                        <div className={css_class.text}>{item.value}</div>
                    </div>
                ))}
            </div>
        </div>
    );
};

// const DataView: React.FC<IPropsDataComboBox> = (props) => {
//     const { data, value, onClick } = props;
// 	const [startIndex, setStartIndex] = useState(0);
//     const containerRef = useRef<HTMLDivElement>(null);

//     const itemHeight = 35; // Высота одного элемента
//     const visibleCount = 5; // Количество видимых элементов

//     const handleScroll = () => {
//         if (containerRef.current) {
//             const scrollTop = containerRef.current.scrollTop;
//             const newStartIndex = Math.floor(scrollTop / itemHeight);
//             setStartIndex(newStartIndex);
//         }
//     };

//     const visibleData = useMemo(() => {
//         return data.slice(startIndex, startIndex + visibleCount);
//     }, [startIndex, data]);

// 	const ClickItem = (item: IComboBoxData): void => {
//         props.onClick(item);
//     };

//     const id = GetGuid();
//     const width = props.width !== undefined ? `${props.width}` : '100%';
//     const viewData = props.data.map((item, ind) => {
//         let classItem = css_class.data_item;
//         if (props.value === item.id) {
//             classItem += ' ' + css_class.sel;
//         }
//         return (
//             <div key={`${item}-${ind}`} className={classItem} onClick={() => ClickItem(item)} title={item.value}>
//                 <div className={css_class.text}>{item.value}</div>
//             </div>
//         );
//     });

//     return (
//         <div key={id} style={{ width: width, height: `calc(${props.data.length} * var(--height_medium))` }} className={css_class.windows}>
//             {viewData}
//         </div>
//     );
// };

export default ComboBox;
